<template>
    <div>
        <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
                <div class="col-lg-6">
                    <h6 class="text-uppercase ls-1 mb-1">Daftar Penugasan</h6>
                </div>
                <div v-if="overview.is_admin" class="col-lg-6 text-lg-right">
                    <b-button variant="primary" size="sm" @click="showTaskFormModal(null)"><i class="fa fa-plus" aria-hidden="true"></i> Tambah Tugas</b-button>
                </div>
            </div>
            <div v-if="overview.task_list && overview.task_list.length > 0" class="text-center text-muted">
                <b-table responsive striped hover :items="overview.task_list" :fields="table.fields" thead-class="d-none">
                    <template #cell(name)="data">
                            <div class="modul-name line-with-icon my-2" style="cursor: pointer;" v-b-toggle="'collapse-task-'+data.item.id">
                                <i class="clr-red fa fa-file" aria-hidden="true"></i>
                                <span class="ml-1">
                                    {{data.item.name}}
                                    <br>
                                    <sup>{{data.item.created}}</sup>
                                </span> <br>
                            </div>
                            <b-collapse :id="'collapse-task-'+data.item.id">
                                <b-card>
                                    <div><i class="clr-red fa fa-book" aria-hidden="true"></i> <b>Bentuk Pengerjaan</b> : {{data.item.view_type}}</div>
                                    <div><i class="clr-red fa fa-calendar" aria-hidden="true"></i> <b>Tenggat Waktu</b> : {{data.item.view_date}}</div>
                                    <div v-if="data.item.type=='ujian'"><i class="clr-red fa fa-clock" aria-hidden="true"></i> <b>Durasi</b> : {{data.item.duration}} menit</div>
                                    <div v-if="data.item.type=='ujian'"><b><i class="clr-red fa fa-lock" aria-hidden="true"></i> Kode Ujian</b> : <span v-if="overview.is_admin==0" class="back-red">Silahkan menghubungi Tutor</span><span v-else class="">{{data.item.code}}</span></div>
                                    <hr>
                                    <div v-if="data.item.is_file==1">
                                        <div v-if="data.item.file_type=='video'" class="card-footer">
                                            <b-button variant="primary" size="sm" @click="openVideo(data.item.file_path,data.item.name)"><i class="fa fa-video" aria-hidden="true"></i> Play</b-button>
                                        </div>
                                        <div v-else style="text-align:center">
                                            <iframe :src="data.item.view_link" width="100%" height="500"></iframe>
                                        </div>
                                    </div>
                                    <div v-else>
                                        {{data.item.description}}
                                    </div>
                                    <hr>
                                    <div v-if="overview.is_admin==0 && ((data.item.is_current_test==1 && data.item.is_has_test==1 &&data.item.score!=0))" class="text-left score">
                                        <i class="clr-red fa fa-calendar-check" aria-hidden="true"></i> <b>Nilai Hasil</b> : <span :class="data.item.score_color" >{{data.item.score}}</span>
                                    </div>
                                    <div class="text-right">
                                        <router-link :to="{ name: 'student-task-list', params:{ taskId: data.item.id} }"><b-button v-if="overview.is_admin" variant="primary" size="sm"><i class="fa fa-eye" aria-hidden="true"></i> Lihat Tugas Siswa</b-button></router-link>
                                        <b-button class="text-left" v-if="overview.is_admin==0 && ((data.item.is_current_test==0) || (data.item.is_current_test==1 && data.item.is_has_test==1 && data.item.score!=0))" variant="primary" size="sm" @click="showNotAvailable(data.item)"><i class="fa fa-eye" aria-hidden="true"></i> Lihat Tugas</b-button>
                                        <b-button v-if="overview.is_admin==0 && data.item.is_current_test==1 && data.item.is_has_test==0 && data.item.type == 'tugas' && data.item.score==0" variant="primary" size="sm" @click="showDoTaskFormModal(data.item)"><i class="fa fa-clock" aria-hidden="true"></i> Kerjakan</b-button>
                                        <b-button v-if="overview.is_admin==0 && data.item.is_current_test==1 && data.item.is_has_test==1 && data.item.type == 'tugas' && data.item.score==0" variant="primary" size="sm" @click="showDoTaskFormModal(data.item)"><i class="fa fa-clock" aria-hidden="true"></i> Kerjakan Ulang</b-button>
                                        <b-button v-if="overview.is_admin==0 && data.item.is_current_test==1 && data.item.is_has_test==0 && data.item.type == 'ujian'" variant="primary" size="sm" @click="showDoTaskFormModal(data.item)"><i class="fa fa-clock" aria-hidden="true"></i> Masuk Ruang Uji</b-button>
                                    </div>
                                </b-card>
                            </b-collapse>
                    </template>
                    <template #cell(actions)="data">
                        <div v-if="overview.is_admin" class="my-2">
                            <a href="javascript:void(0)" class="icon-clicked p-1" @click="showTaskFormModal(data.item)" ><i class="fa fa-edit" aria-hidden="true"></i></a>
                            <a href="javascript:void(0)" class="icon-clicked p-1" @click="confirmDeleteTask(data.item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                        </div>
                        <div v-if="!overview.is_admin" class="my-2">
                            <span :class="data.item.color" >{{data.item.label}}</span>
                        </div>
                    </template>
                </b-table>
            </div>
            <div v-else class="p-2 text-center text-muted">
                Saat ini belum ada tugas
            </div>
        </card>
        <b-modal
			ref="task-form-modal"
			class="task-form-modal"
			size="lg"
            v-bind:title="setTitle"
            @show="resetTaskForm"
            @hidden="resetTaskForm"
			hide-footer
			no-close-on-backdrop
		>
            <task-form
                :modulId="modulId"
                :taskType="type"
                :taskDetail="taskDetail"
                :taskId="taskId"
            ></task-form>
		</b-modal>
		<b-modal
			ref="do-task-form-modal"
			class="do-task-form-modal"
			size="lg"
            v-bind:title="setTitle"
            @show="resetDoTaskForm"
            @hidden="resetDoTaskForm"
			hide-footer
			no-close-on-backdrop
		>
            <do-task-form
                :modulId="modulId"
                :taskId="taskId"
                :duration="taskDuration"
                :taskQuestion="taskQuestion"
                :taskIsFile="taskIsFile"
                :taskFilePath="taskFilePath"
                :taskFileType="taskFileType"
                :taskViewList="taskViewList"
            ></do-task-form>
		</b-modal>
		<b-modal
			ref="check-code-ujian-form-modal"
			class="check-code-ujian-form-modal"
			size="md"
            v-bind:title="'Masukan Kode Ujian'"
            @show="resetCodeUjianForm"
            @hidden="resetCodeUjianForm"
			hide-footer
			no-close-on-backdrop
		>
            <div class="check-code-ujian">
                <b-form data-vv-scope="check-code-ujian">
                    <b-form-group
                        label="Kode Ujian"
                        label-for="code"
                        label-cols-sm="3"
                        label-align-sm="left"
                    >
                        <b-form-input
                            id="code_ujian"
                            name="code_ujian"
                            data-vv-as="Kode Ujian"
                            v-model="check_code_ujian.code"
                            type="text"
                            placeholder="Kode Ujian"
                            v-validate="'required'"
                            autocomplete="off"
                        ></b-form-input>
                        <span :class="{ 'error-validation': errors.first('check-code-ujian.code_ujian') }">{{ errors.first('check-code-ujian.code_ujian') }}</span>
                    </b-form-group>
                </b-form>
            </div>
            <hr>
            <div class="new-class-footer d-flex justify-content-end">
                <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
                <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideDoTaskUjianFormModal">BATAL</b-button>
                <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="checkCodeUjian">SUBMIT</b-button>
            </div>
		</b-modal>
        <b-modal
			ref="student-task-detail-modal"
			class="student-task-detail-modal"
			size="lg"
            title="Tugas Siswa"
			hide-footer
			no-close-on-backdrop
		>
            <div class="student-task-detail">
                <div class="card">
                    <div class="card-header">
                         <div class="d-flex">
                            <div class="left-content mr-2">
                                <div class="media d-flex justify-content-center">
                                    <a href="javascript:void(0)" class="avatar rounded-circle">
                                        <img alt="" :src="studentTaskDetail.tutor_image_path">
                                    </a>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="user-article">
                                    <a href="javascript:void(0);" class="text-uppercase font-weight-bold" v-html="studentTaskDetail.tutor_full_name"></a>&nbsp;
                                    <i class="clr-red fa fa-chevron-circle-right" aria-hidden="true"></i>&nbsp;
                                    <a href="javascript:void(0);" class="text-uppercase font-weight-bold" v-html="studentTaskDetail.judul_task"></a>
                                </div>
                                <div class="role-article">
                                    <small class="text-muted" v-html="studentTaskDetail.created"></small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="studentTaskDetail.is_file==1" class="card-body">
                        <div v-if="studentTaskDetail.file_type=='video'">
                            <video-embed :src="studentTaskDetail.file_path"></video-embed>
                        </div>
                        <div v-else style="text-align:center">
                            <iframe :src="studentTaskDetail.view_link" width="100%" height="300"></iframe>
                        </div>
                    </div>
                    <div v-else class="card-body" v-html="studentTaskDetail.description_task"></div>
                    <div class="card-footer">
                        <a href="javascript:void(0)" class="btn-open-answer" v-b-toggle="'collapse-task-answer'"><i class="clr-red fa fa-file" aria-hidden="true"></i> Lembar Jawaban Siswa</a>
                    </div>
                    <b-collapse :id="'collapse-task-answer'" class="p-4">
                        <div class="d-flex">
                            <div class="left-content mr-2">
                                <div class="media d-flex justify-content-center">
                                    <a href="javascript:void(0)" class="avatar rounded-circle">
                                        <img alt="" :src="studentTaskDetail.siswa_image_path">
                                    </a>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="user-article">
                                    <a href="javascript:void(0);" class="text-uppercase font-weight-bold" v-html="studentTaskDetail.siswa_full_name"></a>&nbsp;
                                    <!-- <i class="clr-red fa fa-chevron-circle-right" aria-hidden="true"></i>&nbsp;
                                    <a href="javascript:void(0);" class="text-uppercase font-weight-bold" v-html="studentTaskDetail.answer"></a> -->
                                </div>
                                <div class="role-article">
                                    <small class="text-muted" v-html="studentTaskDetail.created"></small>
                                </div>
                                <div class="answer-content py-3" v-html="studentTaskDetail.answer">
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
		</b-modal>
        <b-modal
			ref="open-video"
			class="open-video"
			size="lg"
            :title="fileTitle"
			hide-footer
			no-close-on-backdrop
		>
            <div>
                <video-embed :src="filePath"></video-embed>
            </div>
		</b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
	import TaskForm from "../../../components/Main/Task/TaskForm";
	import DoTaskForm from "../../../components/Main/Task/DoTaskForm";
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        components: {
            TaskForm,
            DoTaskForm,
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                modulId: this.$route.params.modulId,
                taskId: null,
                taskDuration: 0,
                taskQuestion: null,
                taskIsFile: 0,
                taskFilePath: '-',
                taskFileType: 'text',
                taskViewList: '',
                setTitle: "",
                filePath: null,
                fileTitle: "",
                taskDetail: {},
                table: {
                    fields: [
                        { key: 'name', label: 'Name', class: 'task-name text-left'  },
                        { key: 'actions', label: 'Actions', class: 'action-column' }
                    ],
                },
                check_code_ujian: {
                    code: null
                }
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                overview: 'getTaskOverview',
                type: 'getTaskType',
                studentTaskDetail: 'getStudentTaskDetail'
            })
        },
        methods: {
            showTaskFormModal(param) {
                if (param) {
                    this.taskId = param.id
                    this.taskDetail = param
                    this.setTitle = "Edit Tugas"
                } else {
                    this.taskDetail = {}
                    this.taskId = null
                    this.setTitle = "Tambah Tugas"
                }
                this.$refs['task-form-modal'].show()
            },
            hideTaskFormModal() {
                this.$refs['task-form-modal'].hide()
            },
            showDoTaskFormModal(param) {
                this.taskId = param.id
                this.taskDuration = param.duration
                this.taskQuestion = param.description
                this.taskIsFile = param.is_file
                this.taskFileType = param.file_type
                this.taskViewList = param.view_link
                this.taskFilePath = param.file_path
                if (param.type == 'tugas') {
                    this.$refs['do-task-form-modal'].show()
                } else {
                    this.$refs['check-code-ujian-form-modal'].show()
					// this.$swal.fire('Perhatian', 'Fitur ujian belum tersedia', 'warning')
                }
            },
            hideDoTaskFormModal() {
                this.$refs['do-task-form-modal'].hide()
            },
            hideDoTaskUjianFormModal() {
                this.$refs['check-code-ujian-form-modal'].hide()
            },
            resetTaskForm() {
                EventBus.$emit('resetTaskForm', true)
            },
            resetDoTaskForm() {
                EventBus.$emit('resetDoTaskForm', true)
            },
            resetCodeUjianForm() {
                this.check_code_ujian.code = null
                this.$validator.reset()
            },
            showStudentTaskDetailModal() {
                this.$refs['student-task-detail-modal'].show()
            },
            hideStudentTaskDetailModal() {
                this.$refs['student-task-detail-modal'].hide()
            },
            openVideo(path,title){
                this.filePath = path;
                this.fileTitle = title;
                this.$refs['open-video'].show()
            },
            async checkCodeUjian() {
                let scope = 'check-code-ujian'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.showLoader = true
                        let form = this.check_code_ujian
                        this.$store.dispatch('getTokenUjian', form)
                            .then((res) => {
                                this.showLoader = false
                                this.hideDoTaskUjianFormModal()
                                this.$router.push({ name: 'ujian', params: { token: res.data.data.token } })
                            })
                            .catch((err)=> {
                                let error = err.response
                                this.showLoader = false
                                this.$swal.fire('Failed', error.data.message, 'error')
                            })
                    }
                });
            },
            async showNotAvailable(param) {
                EventBus.$emit('showLoaderOverlay', true)
                let taskId = param.id
                let userId = this.user.id
				await this.$store.dispatch('getStudentTaskDetail', { taskId, userId })
					.then( async () => {
                        await EventBus.$emit('hideLoaderOverlay', true)
                        await setTimeout(() => this.showStudentTaskDetailModal(), 1000);
					})
					.catch((err)=> {
                        EventBus.$emit('hideLoaderOverlay', true)
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
			async getTaskOverview() {
                let modulId = this.$route.params.modulId
				await this.$store.dispatch('getTaskOverview', { modulId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
			async getTaskType() {
				await this.$store.dispatch('getTaskType')
			},
			async confirmDeleteTask(taskId) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.deleteTask(taskId)
                    }
                })
			},
            async deleteTask(id) {
				await this.$store.dispatch('deleteTask', { id })
					.then((res) => {
                        this.getTaskOverview()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            }
        },
        created() {
            this.setCurrentModulId(this.$route.params.modulId)
            this.getTaskOverview()
            this.getTaskType()
			EventBus.$on('hideTaskFormModal', (val) => {
				if (val) {
					this.hideTaskFormModal()
				}
			})
			EventBus.$on('hideDoTaskFormModal', (val) => {
				if (val) {
					this.hideDoTaskFormModal()
				}
			})
        }
    }
</script>
<style>
.task-name {
    padding-right: 0 !important;
}
</style>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}

.line-with-icon svg {
    /* color: #adb7be; */
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1rem;
}
.line-with-icon {
    position: relative;
    padding: 0 0 0 1.75em;
    margin: 0 0 1em;
}
.user-article a {
    color: black;
}
.class-list > .line-with-icon > a{
    color:#ca062a
}
.user-article a:hover {
    color: #ca062a;
}

.btn-open-answer {
    color: #6c757d
}
.btn-open-answer:hover {
    color: #ca062a;
}
</style>